import { call, put, select, takeLatest } from 'redux-saga/effects'
import { OptionsService } from '../services/options.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import * as actions from '../store/options.actions'
import { IOptionsResponse } from '../../../common/common.types'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* setVentilatorTemperatureUnitOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getVentilatorTempertureOptions])
    const { entity } = response
    yield put(actions.setVentilatorTempertureUnitOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setAirwayTemperatureUnitOptions() error: ${e}`))
  }
}
export function* setVentilatorTemperatureUnitOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setVentilatorTemperatureUnitOptions)
}
